export class Customerwelcome {
    markup: string;
    medialink: string;
    versioncreator: string;
    validfrom: string;
    validto: string;
    customerId: string;
    organizationId: string;
}